module.exports = __webpack_public_path__ + "static/media/Money2.81804173.svg";